module.exports = __webpack_public_path__ + "static/media/icons8-windows-xp.8bb57879.svg";